export const associationFieldDescriptions = [
  {
    name: "legacyId",
    label: "Legacy-ID",
    fieldType: "String",
  },
  {
    name: "bwdvNumber",
    label: "BWDV Nummer",
    fieldType: "Integer",
  },
  {
    name: "name",
    label: "Name",
    fieldType: "String",
  },
  {
    name: "sportbundNumber",
    label: "Mitgliedsnr. Sportbund",
    fieldType: "String",
  },
  {
    name: "chairmanName",
    label: "Vorstand",
    fieldType: "String",
  },
  {
    name: "street",
    label: "Strasse",
    fieldType: "String",
  },
  {
    name: "plz",
    label: "PLZ",
    fieldType: "String",
  },
  {
    name: "city",
    label: "Stadt",
    fieldType: "String",
  },
  {
    name: "email",
    label: "E-Mail",
    fieldType: "String",
  },
];
export const associationLinkDescriptions = [
  {
    linkedRecordType: "team",
    recordField: "teams",
    label: "Mannschaften",
    linkTextRecordFieldName: "representation",
  },
  {
    linkedRecordType: "player",
    recordField: "players",
    label: "Spieler",
    linkTextRecordFieldName: "representation",
  },
];
